import React from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import Toggle from './shared/toggle';
import { getSettings } from '../util/getSettings';
// import { mapVisibilityUpdated } from '../redux/actions/map';

const Breadcrumbs = () => {
  const settings = getSettings(['century', 'settings']);
  // const labels = getSettings(['century', 'labels'], true);
  // const mapState = useSelector((state) => state.map);
  // const regionData = useSelector(state => state.regionData);
  // const dispatch = useDispatch();

  return (
    <nav className="breadcrumb-nav" aria-label="breadcrumbs">
      <ol className='breadcrumb'>
        <li className='breadcrumb-item'>
          <a href="/">Home</a>
        </li>  
        <li className='breadcrumb-item'>
          {settings.communitiesInMetroText}  
        </li>  
      </ol>
    </nav>
  );
};

export default Breadcrumbs;